import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {listProducts, type I18nKey, type Product} from "@corporatesclub/shared";
import {useI18n} from "@/components/shop/I18nProvider";
import {ProductCarousel} from "@/components/shop/ProductCarousel";

const PERFUME_CATEGORY = "fragrance";
const PRODUCT_COUNT = 10;

type Feature = {icon: string; titleKey: I18nKey; bodyKey: I18nKey};

const FEATURES: Feature[] = [
  {
    icon: "fa-diamond",
    titleKey: "Home perfume spotlight feature 1 title",
    bodyKey: "Home perfume spotlight feature 1 body"
  },
  {
    icon: "fa-certificate",
    titleKey: "Home perfume spotlight feature 2 title",
    bodyKey: "Home perfume spotlight feature 2 body"
  },
  {
    icon: "fa-truck",
    titleKey: "Home perfume spotlight feature 3 title",
    bodyKey: "Home perfume spotlight feature 3 body"
  }
];

export function HomePerfumeSpotlight() {
  const {t} = useI18n();
  const [items, setItems] = useState<Product[]>([]);
  useEffect(() => {
    listProducts({c: PERFUME_CATEGORY, pageSize: PRODUCT_COUNT})
      .then((r) => setItems(r.items))
      .catch(() => {});
  }, []);
  if(!items.length) return null;
  return (
    <section className="cc-homePerfumeSpotlight" aria-labelledby="home-perfume-spotlight-title">
      <div className="cc-homePerfumeSpotlight__inner">
        <div className="cc-homePerfumeSpotlight__copy">
          <p className="cc-homePerfumeSpotlight__eyebrow">{t("Carousel hero fragrance eyebrow")}</p>
          <h2 id="home-perfume-spotlight-title" className="cc-homePerfumeSpotlight__title">
            {t("Home perfume spotlight title")}
          </h2>
          <ul className="cc-homePerfumeSpotlight__features">
            {FEATURES.map((f) => (
              <li key={f.titleKey} className="cc-homePerfumeSpotlight__feature">
                <span className="cc-homePerfumeSpotlight__icon" aria-hidden="true">
                  <i className={`fa ${f.icon}`} />
                </span>
                <div>
                  <strong>{t(f.titleKey)}</strong>
                  <p>{t(f.bodyKey)}</p>
                </div>
              </li>
            ))}
          </ul>
          <Link to="/c/fragrance" className="cc-homePerfumeSpotlight__cta">
            {t("Carousel hero fragrance cta")}
          </Link>
        </div>
        <div className="cc-homePerfumeSpotlight__carousel">
          <ProductCarousel products={items} scrollPages={2} />
        </div>
      </div>
    </section>
  );
}
